<!-- eslint-disable prettier/prettier -->
<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="mb-4">
                <e-label>
                  Etapas
                </e-label>
              </div>

              <e-autocomplete
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item?.descricao} - Início: ${dateFormatConvert(
                      item?.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0 mt-10" cols="6">
            <v-chip
              v-if="etapaSelecionada && autorizacoesAprovadas[etapaSelecionada.id || etapaSelecionada]"
              class="mt-2 white--text"
              color="green"
            >
              Esta etapa foi estendida até:
                {{
                  autorizacoesAprovadas[etapaSelecionada.id || etapaSelecionada].data_expiracao
                    ? dateFormatConvert(
                        autorizacoesAprovadas[etapaSelecionada.id || etapaSelecionada]
                          .data_expiracao
                      )
                    : "Sem expiração"
                }}
            </v-chip>
          </v-col>
          <v-col>
            <div v-if="etapaBloqueada == true" class="mt-4">
              <v-btn
                v-if="!etapaPendente"
                color="warning"
                small
                @click="abrirModalSolicitacao"
              >
                <v-icon left small>mdi-send-clock</v-icon>
                Solicitar Autorização
              </v-btn>
              <v-alert
                v-else
                type="warning"
                border="left"
                icon="mdi-clock-outline"
                class="mt-4 mb-0"
              >
                Solicitação pendente de análise.
                <a
                  class="white--text font-weight-bold text-decoration-underline"
                  style="cursor: pointer"
                  @click="verPedidos"
                >
                  Acompanhe aqui.
                </a>
              </v-alert>
            </div>
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="4">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data</e-label>
                  <v-text-field
                    v-model="aulaSelecionada.data"
                    persistent-hint
                    :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container class="calendar-container">
                    <v-row>
                      <!-- Calendário -->
                      <v-col cols="12" md="12" class="d-flex justify-center">
                        <v-card class="calendar-card pa-3" elevation="2" outlined>
                          <v-date-picker
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            color="primary"
                            header-color="primary"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge :content="getBadgeContent(date)" overlap dot>
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                <e-label>Selecione um horário</e-label>
                <e-autocomplete
                  :disabled="aulaSelecionada.data ? false : true"
                  :items="horariosDoComponente"
                  :error-messages="errors"
                  label="Selecione uma opção"
                  :item-text="(item) => item.descricao"
                  v-model="horarioSelecionado"
                  return-object
                  dense
                  @change="pesquisaAulas"
                />
              </ValidationProvider>
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Dia da semana</e-label>
              <v-text-field solo dense v-model="aulaSelecionada.dia_da_semana" :disabled="true">
              </v-text-field>
            </v-col>

            <v-col cols="12"> </v-col>
            <v-col class="pt-0 pb-0" cols="12">
              <h4>Campos de experiencias</h4>
              <v-row class="">
                <v-col class="pt-0 pb-0" cols="4" v-for="(el, index) of opcoes" :key="index">
                  <v-checkbox
                    v-model="campos_de_experiencias[index]"
                    :label="el"
                    :value="el"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="12"
              v-if="horarioSelecionado || aulaSelecionada.tipo_de_aula === 'Aula Remota' || editing"
            >
              <ValidationProvider name="conteudo" rules="required" v-slot="{ errors }">
                <e-label>Eixos temáticos</e-label>
                <v-textarea solo dense v-model="aulaSelecionada.eixos" :error-messages="errors" />
              </ValidationProvider>

              <ValidationProvider name="estrategias" rules="required" v-slot="{ errors }">
                <e-label>Estratégias de ensino </e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.estrategias"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <ValidationProvider name="recursos" rules="required" v-slot="{ errors }">
                <e-label>Recursos</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.recursos"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <ValidationProvider name="atividade_classe" rules="required" v-slot="{ errors }">
                <e-label>Atividade de classe</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.atividade_classe"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <ValidationProvider name="atividade_casa" rules="required" v-slot="{ errors }">
                <e-label>Atividade de casa</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.atividade_casa"
                  :error-messages="errors"
                />
              </ValidationProvider>

              <e-label>Observações</e-label>

              <v-textarea solo dense v-model="aulaSelecionada.observacoes" />
              <v-btn
                color="primary"
                :disabled="submittingForm || aulasConflitadas.length > 0"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.duplicar = true"
                >Duplicar Aula</v-btn
              >
              <v-btn v-if="editing" class="ml-3" color="success" @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false && etapaReprovada == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="red" border="left">
              Atenção, o pedido de estensão para essa etapa foi reprovado. Para lançar aulas você deve solicitar um autorização clicando no botão acima.
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="etapaBloqueada == true && etapaPendente == false && etapaReprovada == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção, essa etapa está bloqueada. Para lançar aulas você deve solicitar uma
              autorização clicando no botão acima.
            </v-alert>
          </v-col>
        </v-row>

        <div v-if="etapas?.length > 0 && etapaBloqueada == false && etapaSelecionada">
          <v-row
            v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data || !horarioSelecionado"
          >
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="conflito" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="conflito = !conflito"> Fechar </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor ?? "- - -" }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item?.franquia ?? "- - -" }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario }}
                  </td>
                  <td>{{ item?.turma ?? "- - -" }}</td>
                  <td>{{ item.disciplina ?? "- - -" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >
    <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :horarios="horarios"
      :allowedDates="allowedDates"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula>
    <e-modal-solicitar-autorizacao
      v-model="modalSolicitarAutorizacao"
      tipo="aula"
      :etapa-id="etapaSelecionada ? etapaSelecionada.id : null"
      :etapa-descricao="etapaSelecionada ? etapaSelecionada.descricao : ''"
      :instrutor-id="gestaoDeAula ? gestaoDeAula.instrutor_id : null"
      :instrutor-disciplina-turma-id="Number($route.params.gestaoDeAulaId) || null"
      @solicitacaoEnviada="aoEnviarSolicitacao"
      @solicitacaoDuplicada="aoEnviarSolicitacao"
    />
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import EModalSolicitarAutorizacao from "../../components/Autorizacao/EModalSolicitarAutorizacao.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel, EModalSolicitarAutorizacao },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
  },
  data() {
    return {
      opcoes: [
        "O eu, o outro e o nós",
        "Corpo, gestos e movimentos",
        "Escuta, fala, pensamento e imaginação",
        "Traços, sons, cores e formas",
        "Espaço, tempo, quantidades, relações e transformações",
      ],
      data: null,
      modal: false,
      menu: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      diasSemana: this.$constants.diasDaSemana,
      mostrarCampos: true,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      experiencias: [],
      campos_de_experiencias: [],
      aulaSelecionada: {
        data: null,
        dia_da_semana: "",
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horariosDoComponente: null,
      conflito: false,
      avisoAnime: "",
      etapaPendente: false,
      etapaReprovada: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      idsEtapasReprovadas: [],
      autorizacao: [],
      autorizacoesAprovadas: {},
      modalSolicitarAutorizacao: false,
      mostrarEtapas: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
    };
  },
  watch: {
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }
    },
    data(value) {
      if (!value) return;

      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));

      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      this.atualizarHorarios();
      this.pesquisaAulas();
      this.diaDaSemana();
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      if (!this.gestaoDeAula.relacoesDiasHorarios) return;

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      this.horarios = horariosDoDia;

      if (diaDaSemana === 5) {
        this.horariosDoComponente = this.horariosSabado;
      } else {
        this.horariosDoComponente = this.horarios;
      }
    },
    async pesquisaAulas() {
      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      const aula_id = this.$route.params.aula_id;
      const horario_id = this.horarioSelecionado?.id;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !this.horarioSelecionado || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.getAulasEmConflitoInfantil(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      const conflito = response.data.conflitos.conflito;
      const aulasConflitadas = response.data.conflitos.aulasConflitadas;
      if (!conflito) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
        this.aulasConflitadas = [];
      }

      if (conflito) {
        this.horarioSelecionado = null;
        this.outrosCampos = false;
        this.aulasConflitadas = aulasConflitadas;
        this.conflito = conflito;
      }
      this.$forceUpdate();
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async formatarCamposDeExperiencia() {
      try {
        const data = [];
        this.opcoes.forEach((opcao, index) => {
          const matches = this.campos_de_experiencias.filter((experiencia) => {
            return experiencia ? experiencia.trim() === opcao.trim() : false;
          });
          const dado = matches.length > 0 ? matches[0] : null;
          this.experiencias.push(dado ?? null);
        });
        this.campos_de_experiencias = this.experiencias;
      } catch (e) {
        this.$handleError(e);
      }
    },
    async submitForm() {
      this.aulaSelecionada.e_aula_infantil = 1;
      this.aulaSelecionada.campos_de_experiencias = this.campos_de_experiencias;
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      this.aulaSelecionada.etapa_id = this.etapaSelecionada.id;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
            this.$route.params.gestaoDeAulaId,
            10
          );
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = parseInt(this.gestaoDeAula.turma_id, 10);
          this.aulaSelecionada.instrutor_id = parseInt(this.gestaoDeAula.instrutor_id, 10);
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          await this.$services.aulasService.criarAula(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulas",
      });
    },
    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.payload.gestaoDeAula;
      this.turma = response.payload.gestaoDeAula.turma;
      this.horariosSabado = response.payload.horarios;

      // this.horarios = await this.$services.horariosService.horariosAll();
      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
      this.horarioSelecionado = aulaSelecionada.horario ?? null;
      this.campos_de_experiencias = aulaSelecionada.campos_de_experiencias
        ? aulaSelecionada.campos_de_experiencias
        : [];
      await this.formatarCamposDeExperiencia();
      this.aulaSelecionada.data = aulaSelecionada.data;
      this.data = aulaSelecionada.data;
      const diaSemana = new Date(this.data).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);
      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);

        if (this.data) {
          this.atualizarHorarios();
        }
      }

      return aulaSelecionada;
    },
    atualizarHorarios() {
      if (!this.data) return;

      const diaSemana = new Date(this.data).getDay();

      this.horariosDoComponente = diaSemana === 5 ? this.horariosSabado : this.horarios;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }

        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
          }
        }
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    diaDaSemana() {
      const data_do_usuario = this.aulaSelecionada.data;
      const data_do_usuario_formatada = data_do_usuario.replace(/\//g, "-");
      const array1 = data_do_usuario_formatada.split("-");
      const array2 = array1.reverse();
      const data_final = new Date(array2[0], parseInt(array2[1], 10) - 1, array2[2]);
      const dia = this.diasSemana[data_final.getDay()];
      this.aulaSelecionada.dia_da_semana = dia;
    },
    allowedDates(val) {
      const array = [...this.diasPermitidosParaCriarAula];

      if (!array.includes(5)) {
        array.push(5);
      }

      if (
        this.data &&
        new Date(val).toISOString().split("T")[0] ===
          new Date(this.data).toISOString().split("T")[0]
      ) {
        return true;
      }

      return array.includes(new Date(val).getDay());
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada.id).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },
    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    abrirModalSolicitacao() {
      this.modalSolicitarAutorizacao = true;
    },
    aoEnviarSolicitacao() {
      this.modalSolicitarAutorizacao = false;
      if (this.etapaSelecionada) {
        this.idsEtapasPendentes.push(this.etapaSelecionada.id);
        this.etapaPendente = true;
      }
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
      if (this.idsEtapasReprovadas.includes(etapa.id)) {
        this.etapaReprovada = true;
      } else {
        this.etapaReprovada = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(
        etapaId,
        "aula",
        Number(this.$route.params.gestaoDeAulaId) || null
      );

      if (response.data.aprovados.length) {
        this.idsEtapasDisponivels.push(etapaId);
        this.$set(this.autorizacoesAprovadas, etapaId, response.data.aprovados[0]);
      }

      if (response.data.pendentes.length) {
        this.idsEtapasPendentes.push(etapaId);
      }

      if (response.data.recusados.length) {
        this.idsEtapasReprovadas.push(etapaId);
      }
    },
    getChipColor(dataExtensao) {
      if (!dataExtensao) return "primary";
      const hoje = new Date();
      const dataExt = new Date(dataExtensao);

      hoje.setHours(0, 0, 0, 0);
      dataExt.setHours(0, 0, 0, 0);

      if (dataExt >= hoje) {
        return "green";
      }
      return "red";
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}
</style>
